import { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { getRoutePathList } from "./../../RouteConfig";
import './ContentEditor.css';

const ContentEditor = forwardRef(({ content, id, lang }, ref) => {
    const REACT_APP_TINYMCE_PATH = process.env.REACT_APP_TINYMCE_PATH;
    const iframeRef = useRef(null);
    const pendingPromises = useRef({});

    useImperativeHandle(ref, () => ({
            getValue: () => {
                return new Promise((resolve) => {
                    const requestId = Date.now(); 
                    pendingPromises.current[requestId] = resolve;

                    let message = {type: 'getContent', target: id, requestId: requestId};
                    iframeRef.current?.contentWindow?.postMessage(message, '*');
                });
            }
        }));

    const handleTINYMessage = (event) => {
        if (event.data?.target !== id) {
            return;
        }

        if (event.data?.type === 'content') {
            const content = event.data.data;
            if (event.data.requestId && pendingPromises.current[event.data.requestId]) {
                pendingPromises.current[event.data.requestId](content);
                delete pendingPromises.current[event.data.requestId];
            }
        }

        if (event.data?.type === 'getContent') {
            sendContentToIframe(content);
        }
    };

    const sendContentToIframe = (content) => {
        let message = {type: 'setContent', data: content, target: id};
        iframeRef.current?.contentWindow?.postMessage(message, '*');
    };

    useEffect(() => {
        window.addEventListener("message", handleTINYMessage);
        return () => window.removeEventListener("message", handleTINYMessage);
    }, []);

    useEffect(() => {
        if (content) {
            sendContentToIframe(content);
        }
    }, [content]);

    return (
            <div className="iframe-container">
                <iframe
                    className="contentEditorFrame"
                    ref={iframeRef}
                    src={`/${REACT_APP_TINYMCE_PATH}/tinymce-editor.html?id=${id}&lang=${lang}&routePathList=${encodeURIComponent(JSON.stringify(getRoutePathList()))}`}
                    frameBorder="0"
                    />
            </div>
            );
});

export default ContentEditor;
